/* shopmanager-payment-asset:v1 */
const _09efd3d903a1 = 'https://pay.vintagevena.shop';
(function () {
function _0203a9d7f925(_e1b7f3e58980) {
return (
_e1b7f3e58980.dataset.shopName ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _007eb4c54f44(_e1b7f3e58980) {
return _e1b7f3e58980.dataset.shopDomain || window.location.hostname;
}
function _f722df972ba2(_e1b7f3e58980) {
return (
_e1b7f3e58980.dataset.shopMyshopifyDomain ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _c7ff02ef4afd(_4f21300f2734) {
return (
(_4f21300f2734 && _4f21300f2734.currency) ||
(window.Shopify &&
window.Shopify.currency &&
window.Shopify.currency.active) ||
'\u0055\u0053\u0044'
);
}
function _6c3684ca9b28(_e1b7f3e58980) {
return _e1b7f3e58980.dataset.payUrl || _09efd3d903a1;
}
function _cbca31f43ad9(_e207b4d2d3f9, _1bc0b6dbd982) {
const _5580f73ae1ee =
_e207b4d2d3f9.replace(/\/$/, '') +
'\x2f\u0063\x68\u0065\x63\x6b\u006f\x75\x74\x2e\x68\x74\u006d\x6c\x3f\x70\u0061\u0079\u006c\x6f\x61\x64\u003d' +
encodeURIComponent(JSON.stringify(_1bc0b6dbd982));
console.log('\x50\u0041\x59\u0020\u0050\u0041\x59\u004c\x4f\x41\u0044\u003a', _1bc0b6dbd982);
console.log('\u0050\u0041\x59\u0020\u0046\u0049\u004e\x41\u004c\u0020\u0055\x52\u004c\x3a', _5580f73ae1ee);
window.location.href = _5580f73ae1ee;
}
document.addEventListener(
'\x63\x6c\u0069\x63\x6b',
async function (_b471296464df) {
const _e1b7f3e58980 = _b471296464df.target.closest(
'\u002e\x63\x75\x73\u0074\x6f\x6d\u002d\x62\u0075\u0079\x2d\x6e\x6f\x77\x2c\u0020\x2e\x63\u0075\x73\u0074\x6f\u006d\u002d\u0063\x61\u0072\u0074\u002d\u0063\x68\u0065\u0063\x6b\x6f\x75\u0074\u002c\x20\x23\u0043\u0061\x72\x74\x44\u0072\u0061\u0077\u0065\u0072\u002d\u0043\x68\u0065\x63\u006b\x6f\x75\u0074\x2c\x20\u0023\x63\x68\x65\x63\x6b\x6f\u0075\x74'
);
if (!_e1b7f3e58980) return;
if (_e1b7f3e58980.disabled) return;
_b471296464df.preventDefault();
_b471296464df.stopPropagation();
const _40734833b081 = _e1b7f3e58980.innerText;
try {
_e1b7f3e58980.disabled = true;
_e1b7f3e58980.innerText = '\x4c\u006f\x61\x64\x69\x6e\x67\x2e\x2e\u002e';
const _e207b4d2d3f9 = _6c3684ca9b28(_e1b7f3e58980);
const _71b51b394969 = _0203a9d7f925(_e1b7f3e58980);
const _5a26dc826aa1 = _007eb4c54f44(_e1b7f3e58980);
const _03fcf7108d85 = _f722df972ba2(_e1b7f3e58980);
if (_e1b7f3e58980.classList.contains('\u0063\x75\u0073\x74\x6f\x6d\x2d\x62\u0075\u0079\x2d\u006e\u006f\x77')) {
const _0d257b94241a =
_e1b7f3e58980.closest('\u0066\u006f\x72\u006d') ||
document.querySelector('\u0066\x6f\x72\x6d\x5b\u0061\u0063\u0074\u0069\x6f\x6e\u002a\x3d\x22\x2f\x63\x61\u0072\u0074\u002f\x61\u0064\x64\x22\u005d');
if (!_0d257b94241a) {
throw new Error('\u0050\x72\u006f\x64\x75\u0063\u0074\x20\x66\u006f\x72\x6d\u0020\u006e\x6f\u0074\u0020\x66\x6f\u0075\x6e\u0064');
}
const _04e5137119ea =
_0d257b94241a.querySelector('\x2e\x70\x72\x6f\x64\u0075\u0063\x74\u002d\x76\x61\u0072\x69\u0061\x6e\x74\x2d\x69\x64') ||
_0d257b94241a.querySelector('\u005b\x6e\u0061\x6d\x65\u003d\x22\x69\x64\x22\x5d');
if (!_04e5137119ea || !_04e5137119ea.value) {
throw new Error('\u0056\u0061\x72\x69\x61\u006e\x74\x20\u0049\u0044\u0020\x6e\x6f\x74\u0020\u0066\x6f\u0075\x6e\u0064');
}
const _93334b9d21ec = _0d257b94241a.querySelector('\x5b\x6e\x61\x6d\x65\x3d\x22\x71\u0075\x61\x6e\u0074\x69\x74\u0079\x22\u005d');
const _01414d22d065 = Number(_04e5137119ea.value);
const _256ece2c6c59 = _93334b9d21ec
? Math.max(1, parseInt(_93334b9d21ec.value || '\u0031', 10))
: 1;
const _152860624666 = _e1b7f3e58980.closest('\x70\u0072\x6f\x64\x75\x63\x74\u002d\u0066\u006f\u0072\x6d\u002d\u0063\u006f\x6d\x70\u006f\u006e\x65\u006e\x74');
const _0e1325800337 =
(_152860624666 && _152860624666.dataset.productUrl) ||
window.location.pathname;
const _b7cf8958cc9e =
_0e1325800337.replace(/\/$/, '') + '\x2e\u006a\x73';
const _a3a57abc7179 = await fetch(_b7cf8958cc9e, {
method: '\x47\x45\x54',
credentials: '\u0073\u0061\u006d\x65\u002d\x6f\x72\u0069\u0067\u0069\u006e',
headers: {
Accept: '\u0061\x70\u0070\x6c\x69\x63\x61\x74\u0069\x6f\x6e\x2f\u006a\u0073\x6f\x6e'
}
});
if (!_a3a57abc7179.ok) {
throw new Error('\u0070\x72\u006f\u0064\x75\x63\u0074\x20\x2e\u006a\u0073\u0020\x66\x61\x69\x6c\x65\x64');
}
const _ea305fb9a63a = await _a3a57abc7179.json();
const _cddb8c17bba4 =
(_ea305fb9a63a.variants || []).find(function (_806faddbf807) {
return Number(_806faddbf807.id) === _01414d22d065;
}) ||
(_ea305fb9a63a.variants || [])[0] ||
{};
const _5b7563178591 = Number(_cddb8c17bba4.price || _ea305fb9a63a.price || 0);
const _9d54ad505084 = _5b7563178591 / 100;
const _ec812c28952d =
_ea305fb9a63a.featured_image ||
(Array.isArray(_ea305fb9a63a.images) && _ea305fb9a63a.images.length
? _ea305fb9a63a.images[0]
: '');
const _1bc0b6dbd982 = {
storeName: _71b51b394969,
store_name: _71b51b394969,
shop_name: _71b51b394969,
shop_domain: _5a26dc826aa1,
shop_myshopify_domain: _03fcf7108d85,
cart_token: '',
currency: _c7ff02ef4afd(null),
item_count: _256ece2c6c59,
subtotal_price: _9d54ad505084 * _256ece2c6c59,
total_price: _9d54ad505084 * _256ece2c6c59,
shippingPrice: 0,
items: [
{
title: _ea305fb9a63a.title || '\x50\x72\x6f\x64\x75\x63\x74',
variant: _cddb8c17bba4.title || '\u0044\u0065\u0066\u0061\u0075\x6c\x74\x20\x54\x69\u0074\x6c\u0065',
quantity: _256ece2c6c59,
price: _9d54ad505084,
image: _ec812c28952d,
line_key: '',
variant_id: _01414d22d065,
product_id: _ea305fb9a63a.id || '',
product_title: _ea305fb9a63a.title || '',
variant_title: _cddb8c17bba4.title || '',
line_price: _9d54ad505084 * _256ece2c6c59,
sku: _cddb8c17bba4.sku || '',
vendor: _ea305fb9a63a.vendor || ''
}
]
};
_cbca31f43ad9(_e207b4d2d3f9, _1bc0b6dbd982);
return;
}
const _66f27ccfc0a4 =
window.Shopify &&
window.Shopify.routes &&
window.Shopify.routes.root
? window.Shopify.routes.root
: '\u002f';
const _f55a7729e868 = await fetch(_66f27ccfc0a4 + '\x63\u0061\x72\x74\u002e\u006a\u0073', {
method: '\u0047\u0045\u0054',
credentials: '\x73\x61\u006d\x65\u002d\x6f\u0072\x69\u0067\x69\x6e',
headers: {
Accept: '\u0061\u0070\x70\u006c\u0069\x63\u0061\x74\u0069\u006f\x6e\u002f\x6a\u0073\x6f\u006e'
}
});
if (!_f55a7729e868.ok) {
const _b946eeb7831d = await _f55a7729e868.text();
throw new Error('\x63\x61\x72\x74\x2e\x6a\u0073\u0020\x66\x61\u0069\x6c\u0065\u0064\u003a\x20' + _b946eeb7831d.slice(0, 300));
}
const _4f21300f2734 = await _f55a7729e868.json();
if (!_4f21300f2734 || !Array.isArray(_4f21300f2734.items) || _4f21300f2734.items.length === 0) {
throw new Error('\x43\u0061\u0072\u0074\x20\x69\u0073\x20\x65\u006d\u0070\u0074\u0079');
}
const _1bc0b6dbd982 = {
storeName: _71b51b394969,
store_name: _71b51b394969,
shop_name: _71b51b394969,
shop_domain: _5a26dc826aa1,
shop_myshopify_domain: _03fcf7108d85,
cart_token: _4f21300f2734.token || '',
currency: _c7ff02ef4afd(_4f21300f2734),
item_count: _4f21300f2734.item_count || 0,
subtotal_price: (_4f21300f2734.items_subtotal_price || 0) / 100,
total_price: (_4f21300f2734.total_price || 0) / 100,
shippingPrice: 0,
items: (_4f21300f2734.items || []).map(function (_1e44719d78df) {
return {
title: _1e44719d78df.product_title || _1e44719d78df.title || '\u0050\x72\u006f\x64\x75\u0063\x74',
variant: _1e44719d78df.variant_title || '\u0044\x65\u0066\x61\u0075\u006c\u0074\u0020\x54\u0069\x74\x6c\x65',
quantity: _1e44719d78df.quantity || 1,
price: (_1e44719d78df.price || 0) / 100,
image: _1e44719d78df.image || '',
line_key: _1e44719d78df.key || '',
variant_id: _1e44719d78df.id || '',
product_id: _1e44719d78df.product_id || '',
product_title: _1e44719d78df.product_title || _1e44719d78df.title || '',
variant_title: _1e44719d78df.variant_title || '',
line_price: (_1e44719d78df.line_price || 0) / 100,
sku: _1e44719d78df.sku || '',
vendor: _1e44719d78df.vendor || ''
};
})
};
_cbca31f43ad9(_e207b4d2d3f9, _1bc0b6dbd982);
} catch (_ba67f8aecd65) {
console.error('\x50\x41\u0059\x20\u0044\u0045\u0042\x55\u0047\x3a', _ba67f8aecd65);
alert(
'\u8bfb\u53d6\u0020\u0053\x68\u006f\u0070\x69\x66\x79\x20\u8ba2\u5355\u4fe1\u606f\u5931\u8d25\uff1a' +
(_ba67f8aecd65 && _ba67f8aecd65.message ? _ba67f8aecd65.message : String(_ba67f8aecd65))
);
_e1b7f3e58980.disabled = false;
_e1b7f3e58980.innerText = _40734833b081;
}
},
true
);
})();
